export default __webpack_public_path__ + "static/media/NA.948d0c30.ico";